import React from 'react';
import { TypographyMuted, TypographySmall } from '@/Components/shadcn';
import { RoleItemProps } from '../../Hooks/useRolePickerColumns';

interface RoleColumnCellProps {
    value: RoleItemProps;
}

function RoleColumnCell({ value }: RoleColumnCellProps): React.JSX.Element {
    return (
        <div className="flex flex-col">
            <TypographySmall className="font-bold">{value.name}</TypographySmall>
            <TypographyMuted className="break-words whitespace-normal">{value.description}</TypographyMuted>
        </div>
    );
}

export default RoleColumnCell;
